import store from "./../store";
import router from "./../router";
import DashboardAPI from "./../api/dashboard";


export const formatarValorMonetario = valor => {
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
    }).format(valor);
};

export const formatarValor = valor => {
    return new Intl.NumberFormat("pt-BR", {
        style: "decimal",
        maxDigits: 4
    }).format(valor);
};

export const formatarValorPercent = valor => {
    return new Intl.NumberFormat("pt-BR", {
        style: "percent",
        maxDigits: 2
    }).format(valor);
};

export const exibirMensagem = (mensagem, color, timeout) => {
    const snackbar = { mensagem, color, timeout, ativo: true };
    store.dispatch("snackbar/habilitarSnackBar", snackbar);
};

export const verificarToken = () => {
    if (!localStorage.getItem("token")) router.push({ name: "Home" });

    const headers = iniciarRequisicao();

    DashboardAPI.getValidateUser(headers)
        .then(response => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            let hash = localStorage.getItem("hash_acesso");
            let user = response.data.user;


            if (hash != user.hash_acesso) {
                alert(
                    "A licença do usuário já esta sendo utilizada em outro dispositivo."
                );
                router.push({ name: "Home" });
            }
        })
        .catch(() => {
            logout();
        });
};

export const logout = () => {
    const itens = [
        "token",
        "nome",
        "service",
        "setor",
        "hash_acesso",
        "urls",
        "empresa",
        "id",
        "filial_compra",
        "fator_atuacao",
        "equipe",
        "controle"
    ];

    itens.forEach(item => {
        localStorage.removeItem(item);
    });

    router.push({ name: "Home" });
};

export const getHeaderRequisicao = () => {

    const token = localStorage.getItem("token");

    const headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`
    };

    store.dispatch("loading/habilitarLoading", false);

    return headers;
};



export const iniciarRequisicao = () => {


    const token = localStorage.getItem("token");

    const headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`
    };

    store.dispatch("loading/habilitarLoading", true);

    return headers;
};